import { Component, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { DateRange } from 'src/app/shared/components/date-range.component';
import moment from 'moment';
import { SharedModule } from 'src/app/shared/shared.module';
import { AuthenticationModule } from 'src/app/authentication/authentication.module';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-vessels-toolbar',
  templateUrl: './vessels-toolbar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports:[
    SharedModule,
    RouterModule,
    AuthenticationModule,
    MatButtonModule,
  ]
})
export class VesselsToolbarComponent {

  dateRange: DateRange = {
    startDate: new Date(),
    endDate: new Date()
  };

  @Output()
    activeFilterChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output()
    searchTextChange: EventEmitter<string> = new EventEmitter<string>();

  _activeVesselsFilter = true;
  get activeVesselsFilter() {
    return this._activeVesselsFilter;
  }

  set activeVesselsFilter(value: boolean) {
    this._activeVesselsFilter = value;
    this.activeFilterChange.emit(this._activeVesselsFilter);
  }

  _searchText = '';

  get searchText() {
    return this._searchText;
  }

  set searchText(value: string) {
    this.searchTextChange.emit(value);
  }

  constructor(private _router: Router,) {}

  addVessel() {
    this._router.navigate(['vessels/vessel']).then();
  }

  navigateToInternalAuditPage() {
    this._router.navigate(['vessels/vessel/internal-audit']).then();
  }

  addVoyage() {
    this._router.navigate(['vessels/voyage']).then();
  }

  addOffHire() {
    this._router.navigate(['vessels/off-hire']).then();
  }

  navigateToVoyages() {
    this.dateRange.startDate = moment().subtract('year', 1).toDate();
    this.dateRange.endDate = moment().toDate();
    this._router.navigate(['vessels/voyages/'], {
      queryParams: {
        startTime: this.dateRange?.startDate.getTime(),
        endTime: this.dateRange?.endDate.getTime()
      }
    }).then();
  }

  navigateToFleetHistory() {
    this.dateRange.startDate = moment().subtract('year', 1).toDate();
    this.dateRange.endDate = moment().toDate();
    this._router
      .navigate(['vessels/navigation-history/'], {
        queryParams: {
          startTime: this.dateRange?.startDate.getTime(),
          endTime: this.dateRange?.endDate.getTime()
        }
      }).then();
  }

  navigateToBunker() {
    this.dateRange.startDate = moment().subtract('year', 1).toDate();
    this.dateRange.endDate = moment().toDate();
    this._router
      .navigate(['vessels/bunker/'], {
        queryParams: {
          startTime: this.dateRange?.startDate.getTime(),
          endTime: this.dateRange?.endDate.getTime()
        }
      }).then();
  }

  navigateToNoonReportsV202005() {
    this.dateRange.startDate = moment().subtract('month', 3).toDate();
    this.dateRange.endDate = moment().toDate();
    this._router.navigate(['vessels/noon-reports/v202005/'], {
      queryParams: {
        startTime: this.dateRange?.startDate.getTime(),
        endTime: this.dateRange?.endDate.getTime()
      }
    }).then();
  }

  navigateToNoonReportsV202205() {
    this.dateRange.startDate = moment().subtract('month', 3).toDate();
    this.dateRange.endDate = moment().toDate();
    this._router.navigate(['vessels/noon-reports/v202205/'], {
      queryParams: {
        startTime: this.dateRange.startDate.getTime(),
        endTime: this.dateRange.endDate.getTime()
      }
    });
  }

  navigateToPortDues() {
    this.dateRange.startDate = moment().subtract('year', 1).toDate();
    this.dateRange.endDate = moment().toDate();
    this._router.navigate(['vessels/reports/'], {
      queryParams: {
        startTime: this.dateRange?.startDate.getTime(),
        endTime: this.dateRange?.endDate.getTime()
      }
    }).then();
  }
}
